import { lazy } from 'react';
import Loadable from 'ui-component/Loadable';
import Approved from 'views/Projects/views/Approved';
import Archived from 'views/Projects/views/Archived';
import Pending from 'views/Projects/views/Pending';
import Rejected from 'views/Projects/views/Rejected';
import { UploadFormatFileValidating } from 'views/UsersManagement/components/UploadFormatFileValidating';

const ProjectsView = Loadable(lazy(() => import('views/Projects')));
const CreateProject = Loadable(lazy(() => import('views/CreateProject')));
const DetailProject = Loadable(lazy(() => import('views/DetailProject')));

const MyProjectsRouters = [
  {
    path: 'projects',
    element: <ProjectsView />
  },
  {
    path: 'approve',
    element: <Approved />
  },
  {
    path: 'pending',
    element: <Pending />
  },
  {
    path: 'rejected',
    element: <Rejected />
  },
  {
    path: 'archived',
    element: <Archived />
  },
  {
    path: 'create-project',
    element: <CreateProject />
  },
  {
    path: 'detail-project',
    element: <DetailProject />
  },
  {
    path: 'upload-format-file-validating',
    element: <UploadFormatFileValidating />
  }
];

export default MyProjectsRouters;
